import { useNavigate } from '@/shared/modern-router';
import { LazyImage } from '@crehana/compass.ui';

import ArrowLeft from '@crehana/compass.icons.outline/ArrowLeft';

import { useTranslation } from './hooks';

export const NotFoundPID = () => {
  const { t } = useTranslation();
  const { goBack } = useNavigate();

  const img =
    'https://crehana-vercel-images-prd.imgix.net/public/talent-mf/973a8681-c586-48e3-a2d9-264d7cbc5116-not-found.png?auto=format&fit=clip';

  return (
    <div className=" tw-flex tw-py-0 tw-px-4 tw-items-center tw-justify-center tw-rounded-0.8 tw-bg-neutral-light-100 tw-shadow-01 tw-h-[100vh] tw-w-full">
      <div className="tw-inline-block">
        <div>
          <div className="tw-flex  tw-justify-center tw-items-center">
            <LazyImage
              src={img}
              alt="not-found-page"
              style={{
                width: '152px',
                height: '152px',
              }}
              imgStyle={{
                width: '152px',
                height: '152px',
                objectFit: 'cover',
              }}
            />
          </div>
        </div>
        <div className="tw-flex tw-justify-center tw-items-center tw-pt-2.4">
          <span className="tw-font-subtitle4 tw-text-neutral-light-800 tw-mb-1.2">
            {t('TITLE_PAGE_NOT_FOUND')}
          </span>
        </div>
        <div className="tw-flex tw-justify-center tw-items-center">
          <span className="tw-font-body4 tw-text-neutral-light-700">
            {t('DESCRIPTION_PAGE_NOT_FOUND')}
          </span>
        </div>
        <div className="tw-flex tw-justify-center tw-items-center tw-mt-2.4">
          <button
            type="button"
            className="tw-btn-primary-m tw-btn-icon"
            onClick={goBack}
          >
            <ArrowLeft size={24} />
            {t('BACK')}
          </button>
        </div>
      </div>
    </div>
  );
};
